import React, { useState } from 'react';
import arrow_icon from "../../../assets/images/small-arrow.svg";

const Catalog = (props) => {

    const [catalogArr, setCatalogArr] = useState(props.categories);
    const [opendCategories, setOpenedCategories] = useState([]);

    const toggleCategory = (id) => {
        let newActiveMenus = [...opendCategories];

        if (newActiveMenus.includes(id)) {
          let index = newActiveMenus.indexOf(id);
          if (index > -1) {
            newActiveMenus.splice(index, 1);
          }
        } else {
          newActiveMenus.push(id);
        }

        setOpenedCategories(newActiveMenus);
    }

    return (


        <div className="products_catalog">

            <div className="products_catalog-content">

            <ul className="products_catalog-nav">
                {catalogArr.map((category) => {
                    return (
                    <li className="products_catalog-nav_item">
                        <a className="item_text" href={category.catalog_url}>
                        {category.localazed_name}
                        </a>
                        <img src={arrow_icon}></img>

                        {category.subcategories.length > 0 && (
                        <div className="products_catalog-nav_item-sub">
                            <h6>{category.localazed_name}</h6>
                            <ul className="products_catalog-nav_item-sub-content">
                            {category.subcategories.map((subcategory) => {
                                return (
                                <div className='item-wrapper'>
                                    <li
                                    className={`products_catalog-nav_item-sub-content__item ${
                                        subcategory.subcategories.length > 0
                                        ? "sub-content__item-drop"
                                        : ""
                                    }`}
                                    >
                                    <a className="item-link" href={subcategory.catalog_url}>
                                        {subcategory.localazed_name}
                                    </a>
                                    {subcategory.subcategories.length > 0 && (
                                        <span className={`catalog-sub-dropdown-icon ${opendCategories.includes(subcategory.id) ? "catalog-sub-dropdown-icon-open" : ""}`} onClick={() => toggleCategory(subcategory.id)}></span>
                                    )}
                                    </li>
                                    {subcategory.subcategories.length > 0 ? (
                                    <ul className={`sub_dropdown ${opendCategories.includes(subcategory.id) ? "sub_dropdown-open" : ""}`}>
                                        {subcategory.subcategories.map((lastCategory) => {
                                        return (
                                            <li className='sub_dropdown-item'>
                                                <a className='sub_dropdown-item-link' href={lastCategory.catalog_url}>{lastCategory.localazed_name}</a>
                                            </li>
                                        );
                                        })}
                                    </ul>
                                    ) : (
                                    ""
                                    )}
                                </div>
                                );
                            })}
                            </ul>
                        </div>
                        )}
                    </li>
                    );
                })}
                </ul>

                <div className="catalog-buttons">

                </div>
        </div>
    </div>





    );
};

export default Catalog;
